export default "__VITE_ASSET__cb61966e__"